import { AUTH_GET } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const fetchWebhookLogs = createAsyncThunk(
    "webhook-logs/get",
    async (
        params: { page: number; limit: number;[key: string]: any },
        { rejectWithValue }
    ) => {
        const { page, limit, ...rest } = params;
        try {
            const url = new URL(`${config.baseURL}/api/webhook-logs`);
            url.searchParams.append("limit", String(limit));
            url.searchParams.append("skip", String((page - 1) * limit));
            // Add any additional params from rest
            Object.entries(rest).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                    url.searchParams.append(key, String(value));
                }
            });

            const response = await AUTH_GET(url.toString(), {
                tags: ["webhook-logs", `page:${url.toString()} `],
            });
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);